export default __webpack_public_path__ + "static/media/cabinet1-before-1920w.c26230d7.avif";